import { Select, Input, Typography, TextField, Autocomplete } from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';
import { ReactComponent as XIcon } from './../../assets/icons/base/x.svg';
import { LoadingButtonStyled } from '../styled-components/LoadingButtonStyled';

export const HotlistModalWrapper = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 966px;
  width: 100%;
  padding: 32px;
  padding-top: 21px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.base.background};
`;

export const NotesContainer = styled(Box)`
  max-width: 605px;
  width: 100%;
`;

export const ExpTimeContainer = styled(Box)`
  width: 290px;
`;

export const PlateInput = styled(Input)`
  padding: 10px 14px;
  border-radius: 8px;
  width: 174px;
  height: 48px;
  border: solid 1px ${({ theme }) => theme.palette.grey[300]};
  letter-spacing: 0.1px;

  &.Mui-error {
    border: solid 1px ${({ theme }) => theme.palette.error[400]};
  }
  input::placeholder {
    opacity: 1;
    color: ${({ theme }) => theme.palette.grey[500]}
  }
`;

export const AutoCompleteWrapperStyled = styled(Autocomplete)`
  input::placeholder {
    opacity: 1;
    color: ${({ theme }) => theme.palette.grey[500]}
  }
`;

type ChipStyledType = {
  picked: boolean;
};
export const ChipStyled = styled.div<ChipStyledType>`
  display: flex;
  flex: 45%;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.picked && '#25CEDE'};
  color: ${(props) => props.picked ? 'white' : 'rgba(37, 206, 222, 1)'};
  transition: 0.2s background-color ease-out;
  height: 60px;
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: ${(props) => props.picked ? 'bold' : 'inherit'};
  border: ${(props) => props.picked ? 'none' : '1px solid #25CEDE'} !important;
  cursor: pointer;
`;

export const AutoCompleteInput = styled(TextField)`
  border-radius: 8px;
  /* max-height: 44px; */
  padding: 1px 5px;
  border: solid 1px
    ${({ error, theme }) => error ? theme.palette.error[400] : theme.palette.grey[300]};
  letter-spacing: 0.1px;
  display: flex;
  justify-content: center;
  align-items: center;

  * fieldset {
    border: none;
  }

 
  input {
    padding: 2px !important;
  }
`;

export const StyledInputNotes = styled(Input)`
  padding: 10px 14px;
  border-radius: 8px;
  width: 605px;
  border: solid 1px ${({ theme }) => theme.palette.grey[400]};
  letter-spacing: 0.1px;
  border: solid 1px ${({ theme }) => theme.palette.grey[300]};
  textarea::placeholder {
    opacity: 1;
    color: ${({ theme }) => theme.palette.grey[500]};
  }
  height: 134px;
  &.Mui-error {
    border: solid 1px red;
  }
`;

export const SelectionHotlist = styled(Select)`
  padding: 11px 26px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.grey[400]};
  letter-spacing: 0.1px;
  height: 48px;

  fieldset {
    border: none;
  }
`;

export const HotlistModalH1 = styled(Typography)`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 25px;
`;
export const HotlistModalH2 = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 12px;
`;

export const AddPlateButton = styled(LoadingButtonStyled)`
  width: 110px;
  padding: 0;
  font-weight: 500;
  padding: 10px 18px;
`;

export const CrossIcon = styled(XIcon)`
  margin-left: auto;
  position: absolute;
  right: 32px;
  top: 30px;
  > path {
    stroke: ${({ theme }) => theme.palette.primary[700]};
  }
  cursor: pointer;
`;

export const Divider = styled.hr`
  border-top: solid 1px ${({ theme }) => theme.palette.grey[200]};
  margin-bottom: 2rem;
`;

export const DashboardTabs = styled(Box)(({ theme }) => ({
  display: 'flex',
  outline: `solid 1px ${theme.palette.divider}`,
  marginBottom: '2rem',
  width: 'calc(100% + 64px)',
  marginLeft: '-32px',
}));

export const DeleteModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 400px;
  width: 100%;
  padding: 32px;
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows[29]};
  background-color: ${({ theme }) => theme.palette.base.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  outline: none;
`;
